import React from "react"

export const EditInfoButton = ({ onClick, text = "Edit Info" }) => {
  return (
    <button type="button" onClick={onClick} className="edit-info-button">
      {text}
    </button>
  )
}
